import React from 'react';
import * as commonApi from "../../../api/common-api";
import axios from 'axios';

class ProfileAbout extends React.Component {
    constructor(props) {
        super(props);
        super(props);

        var my = false;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }

        this.state = {
            loading: false,
            profileId: this.props.profileId,
            my: my,
            bio: "",
            ebio: "",
            show: false
        };
    }


    componentDidMount() {
        console.log(this.state)
        this.setState({loading: true, bio: this.props.cuser.about_account}, () => {
            this.getBio();
        });
    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my, bio: ""}, () => {
                this.getBio();
            });
        } else {
            this.setState({profileId: nextProps.profileId, my: my});
        }
    }

    getBio() {
        axios.get(commonApi.getAPIURL() + '?api=getUserBio&user_id=' + this.props.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({bio: response.data.data.about_account});
                }
                this.setState({loading: false});
                return response;
            });
    }

    render() {
        return (
            <div className="page_course_box profile_content_wrapper" id="root-linkedin">
                <div className="title_box mb5">
                    <img src="/static/img/appimg/icon_skill.png"/>
                    <div className="title">About</div>
                </div>
                <div className="body_box">
                    <div className="description">
                        {this.state.bio}
                    </div>
                </div>
            </div>
        )
    }
}

export default ProfileAbout;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_about.js
 **/